// Mock Data for Client Cases
// Stage 1: Individual Client Dashboard - Complete Structure

// Client Information
export const clientInfo = {
  clientId: 'WZ-CLIENT-2024-089',
  name: 'أحمد بن عبدالله السالم',
  email: 'ahmad.salem@example.com',
  phone: '+966 50 123 4567',
  registrationDate: '2023-06-15'
};

// Power of Attorneys (الوكالات)
export const powerOfAttorneys = [
  {
    id: 'POA-001',
    title: 'وكالة عامة',
    issueDate: '2024-01-10',
    expiryDate: '2025-01-10',
    status: 'سارية',
    statusColor: '#10B981',
    issuedFor: 'مكتب وازن للمحاماة',
    scope: 'التمثيل القانوني الكامل في جميع القضايا',
    documentUrl: '/documents/poa-001.pdf'
  },
  {
    id: 'POA-002',
    title: 'وكالة خاصة - قضية عمالية',
    issueDate: '2024-02-15',
    expiryDate: '2024-12-31',
    status: 'سارية',
    statusColor: '#10B981',
    issuedFor: 'أ. محمد العتيبي',
    scope: 'التمثيل في القضية رقم WZ-2024-001',
    documentUrl: '/documents/poa-002.pdf'
  }
];

// Service Requests (الطلبات)
export const serviceRequests = [
  {
    id: 'REQ-001',
    type: 'طلب توثيق',
    title: 'توثيق عقد بيع',
    submissionDate: '2024-11-20',
    status: 'قيد المعالجة',
    statusColor: '#F59E0B',
    assignedTo: 'أ. سارة الأحمدي',
    description: 'طلب توثيق عقد بيع عقار'
  },
  {
    id: 'REQ-002',
    type: 'طلب تسجيل عيني',
    title: 'تسجيل عقار',
    submissionDate: '2024-11-25',
    status: 'مكتمل',
    statusColor: '#10B981',
    assignedTo: 'أ. خالد المطيري',
    description: 'تسجيل عقار في الصك',
    completionDate: '2024-11-28'
  }
];

export const mockCases = [
  {
    id: 'WZ-2024-001',
    caseNumber: 'WZ-2024-001',
    clientFileNumber: 'CF-2024-089-001',
    
    // بيانات رأسية للقضية/المعاملة
    caseType: 'دعوى قضائية',
    title: 'قضية عمالية',
    category: 'عمالي',
    currentStatus: 'جاري المتابعة',
    statusColor: '#2563EB',
    authority: 'المحكمة العمالية بالرياض',
    authorityType: 'محكمة',
    circuit: 'الدائرة العمالية الثالثة',
    registrationDateInWazin: '2024-01-15',
    lastUpdate: '2024-11-28',
    
    // المحامي المكلف
    assignedLawyer: {
      name: 'أ. محمد العتيبي',
      title: 'محامٍ مسؤول',
      phone: '+966 50 123 4567',
      email: 'mohammed.otaibi@wazin.sa',
      photo: null
    },
    assistantLawyer: {
      name: 'أ. سارة الأحمدي',
      title: 'محامٍ معاون',
      phone: '+966 55 987 6543',
      email: 'sarah.ahmadi@wazin.sa'
    },
    
    // تفاصيل القضية الرئيسية (Main Panel)
    caseDetails: {
      subject: 'دعوى المطالبة بمستحقات نهاية الخدمة والتعويضات المستحقة عن الفصل التعسفي',
      grounds: [
        'عدم صرف مستحقات نهاية الخدمة البالغة 45,000 ريال',
        'فصل تعسفي بدون سبب مشروع',
        'عدم صرف الرواتب المتأخرة لمدة 3 أشهر',
        'عدم صرف مكافأة نهاية الخدمة وفقاً لنظام العمل'
      ],
      demands: [
        'المطالبة بصرف مستحقات نهاية الخدمة كاملة',
        'المطالبة بالتعويض عن الفصل التعسفي',
        'المطالبة بالرواتب المتأخرة',
        'إلزام المدعى عليه بالمصروفات والأتعاب'
      ],
      legalPath: 'تم تقديم الدعوى أمام المحكمة العمالية وفقاً للمادة 227 من نظام العمل السعودي. القضية تسير في المسار النظامي وفقاً لإجراءات نظام المرافعات الشرعية.',
      legalOpinion: 'بناءً على دراسة المكتب للقضية والمستندات المقدمة، نرى أن موقف المدعي قوي ومدعوم بالمستندات والإثباتات. عقد العمل واضح، وثبوت العلاقة التعاقدية قائم. ننصح بالمضي في الدعوى حتى صدور الحكم النهائي.'
    },
    
    // مراحل القضية
    caseStages: [
      { id: 1, name: 'تقديم الدعوى', date: '2024-01-15', status: 'مكتمل', statusColor: '#10B981' },
      { id: 2, name: 'إعلان الخصم', date: '2024-01-25', status: 'مكتمل', statusColor: '#10B981' },
      { id: 3, name: 'الجلسة الأولى', date: '2024-02-01', status: 'مكتمل', statusColor: '#10B981' },
      { id: 4, name: 'تقديم المذكرات', date: '2024-11-20', status: 'جاري', statusColor: '#F59E0B' },
      { id: 5, name: 'جلسة المرافعة', date: '2024-12-15', status: 'قادم', statusColor: '#6B7280' },
      { id: 6, name: 'صدور الحكم', date: null, status: 'معلق', statusColor: '#6B7280' }
    ],
    // أطراف الدعوى
    parties: [
      { 
        role: 'المدعي', 
        name: 'أحمد بن عبدالله السالم', 
        type: 'client',
        idNumber: '1234567890',
        capacity: 'فرد',
        address: 'الرياض، حي النخيل',
        phone: '+966 50 123 4567',
        email: 'ahmad@example.com'
      },
      { 
        role: 'المدعى عليه', 
        name: 'شركة النور للتجارة', 
        type: 'opponent',
        crNumber: '1010123456',
        capacity: 'شركة',
        address: 'الرياض، حي العليا',
        phone: '+966 11 234 5678',
        representative: 'محمد بن سعد المطيري'
      }
    ],
    // مواعيد الجلسات
    hearings: [
      {
        id: 'H1',
        date: '2024-02-01',
        day: 'الخميس',
        time: '10:00 صباحاً',
        location: 'المحكمة العمالية - القاعة 3',
        status: 'منتهية',
        statusColor: '#6B7280',
        notes: 'تم تأجيل الجلسة لحين تقديم المستندات',
        attendees: ['أ. محمد العتيبي', 'وكيل المدعى عليه']
      },
      {
        id: 'H2',
        date: '2024-12-15',
        day: 'الأحد',
        time: '11:00 صباحاً',
        location: 'المحكمة العمالية - القاعة 5',
        status: 'قادمة',
        statusColor: '#F59E0B',
        notes: 'جلسة النظر في الأدلة والمرافعة النهائية',
        attendees: ['أ. محمد العتيبي']
      }
    ],
    
    // المذكرات
    memorandums: [
      {
        id: 'MEM1',
        title: 'مذكرة الدعوى الابتدائية',
        type: 'مذكرة دعوى',
        submissionDate: '2024-01-15',
        submittedBy: 'أ. محمد العتيبي',
        pages: 8,
        summary: 'مذكرة تأسيس الدعوى وبيان الوقائع والطلبات',
        documentUrl: '/documents/memorandum-001.pdf',
        canDownload: true
      },
      {
        id: 'MEM2',
        title: 'مذكرة دفاع تكميلية',
        type: 'مذكرة دفاع',
        submissionDate: '2024-11-20',
        submittedBy: 'أ. محمد العتيبي',
        pages: 12,
        summary: 'مذكرة دفاع تكميلية مع إضافة مستندات جديدة',
        documentUrl: '/documents/memorandum-002.pdf',
        canDownload: true
      }
    ],
    
    // الضبوط (محاضر الجلسات)
    sessionRecords: [
      {
        id: 'SR1',
        sessionNumber: 'ج-001',
        date: '2024-02-01',
        title: 'محضر الجلسة الأولى',
        summary: 'محضر جلسة التأجيل الأولى لتقديم المستندات',
        content: 'حضر وكيل المدعي وطلب مهلة لتقديم المستندات الإضافية. قررت المحكمة التأجيل لجلسة 15/12/2024.',
        documentUrl: '/documents/session-record-001.pdf',
        canDownload: true
      }
    ],
    
    // القرارات الصادرة من الجهة المختصة
    authorityDecisions: [
      {
        id: 'AD1',
        decisionNumber: 'ق-2024-001-15',
        date: '2024-02-01',
        type: 'قرار تأجيل',
        title: 'قرار تأجيل الجلسة',
        summary: 'تأجيل النظر في الدعوى لجلسة 15/12/2024',
        issuedBy: 'قاضي الدائرة العمالية الثالثة',
        documentUrl: '/documents/decision-ad-001.pdf',
        canDownload: true
      },
      {
        id: 'AD2',
        decisionNumber: 'ق-2024-001-28',
        date: '2024-11-20',
        type: 'قرار إجرائي',
        title: 'قرار قبول المذكرة التكميلية',
        summary: 'قبول المذكرة التكميلية المقدمة من وكيل المدعي',
        issuedBy: 'قاضي الدائرة العمالية الثالثة',
        documentUrl: '/documents/decision-ad-002.pdf',
        canDownload: true
      }
    ],
    // القرارات الصادرة
    issuedDecisions: [
      {
        id: 'D1',
        date: '2024-02-01',
        type: 'قرار تأجيل',
        decisionNumber: 'D-2024-001-01',
        summary: 'تأجيل القضية لجلسة 15/12/2024',
        details: 'قررت المحكمة تأجيل النظر في القضية لحين استكمال المستندات المطلوبة',
        issuedBy: 'قاضي المحكمة العمالية',
        documentUrl: '/documents/decision-001.pdf'
      },
      {
        id: 'D2',
        date: '2024-11-20',
        type: 'قرار إجرائي',
        decisionNumber: 'D-2024-001-02',
        summary: 'قبول المذكرة الدفاعية',
        details: 'قبول المذكرة الدفاعية المقدمة من وكيل المدعي',
        issuedBy: 'قاضي المحكمة العمالية',
        documentUrl: '/documents/decision-002.pdf'
      }
    ],
    
    // الإقرارات
    statements: [
      {
        id: 'ST1',
        date: '2024-01-15',
        type: 'إقرار دعوى',
        title: 'إقرار تقديم الدعوى',
        description: 'إقرار رسمي بتقديم الدعوى العمالية',
        documentUrl: '/documents/statement-001.pdf'
      },
      {
        id: 'ST2',
        date: '2024-11-20',
        type: 'إقرار دفاع',
        title: 'إقرار المذكرة الدفاعية',
        description: 'إقرار تقديم المذكرة الدفاعية',
        documentUrl: '/documents/statement-002.pdf'
      }
    ],
    
    // المحاضر
    minutes: [
      {
        id: 'MIN1',
        date: '2024-02-01',
        type: 'محضر جلسة',
        sessionNumber: 'S-001',
        title: 'محضر الجلسة الأولى',
        description: 'محضر جلسة التأجيل الأولى',
        attendees: ['أ. محمد العتيبي', 'وكيل المدعى عليه'],
        documentUrl: '/documents/minutes-001.pdf'
      }
    ],
    
    decisions: [
      {
        id: 'D1',
        date: '2024-02-01',
        type: 'قرار تأجيل',
        summary: 'تأجيل القضية لجلسة 15/12/2024',
        details: 'قررت المحكمة تأجيل النظر في القضية لحين استكمال المستندات المطلوبة'
      }
    ],
    // الطلبات المقدمة أمام الجهة المختصة
    submittedRequests: [
      {
        id: 'REQ1',
        requestNumber: 'ط-2024-001',
        date: '2024-01-20',
        type: 'طلب مستندات',
        title: 'طلب إلزام المدعى عليه بتقديم كشف حساب بنكي',
        status: 'مكتمل',
        statusColor: '#10B981',
        description: 'طلب إلزام المدعى عليه بتقديم كشف الحساب البنكي الخاص بالرواتب',
        response: 'تم الموافقة وإلزام المدعى عليه',
        documentUrl: '/documents/request-001.pdf'
      },
      {
        id: 'REQ2',
        requestNumber: 'ط-2024-002',
        date: '2024-11-15',
        type: 'طلب استدعاء شهود',
        title: 'طلب استدعاء شاهدين',
        status: 'قيد المعالجة',
        statusColor: '#F59E0B',
        description: 'طلب استدعاء شاهدين من زملاء العمل لإثبات واقعة الفصل',
        response: 'قيد النظر من المحكمة',
        documentUrl: '/documents/request-002.pdf'
      }
    ],
    
    // التقارير
    reports: [
      {
        id: 'REP1',
        reportNumber: 'تق-001',
        date: '2024-01-18',
        title: 'تقرير الحالة الأولي للقضية',
        type: 'تقرير حالة',
        preparedBy: 'أ. محمد العتيبي',
        summary: 'تقرير شامل عن وضع القضية والإجراءات المتخذة',
        pages: 5,
        documentUrl: '/documents/report-001.pdf',
        canDownload: true
      },
      {
        id: 'REP2',
        reportNumber: 'تق-002',
        date: '2024-11-25',
        title: 'تقرير تحديث القضية',
        type: 'تقرير تحديث',
        preparedBy: 'أ. محمد العتيبي',
        summary: 'تقرير بآخر المستجدات والإجراءات الحالية',
        pages: 3,
        documentUrl: '/documents/report-002.pdf',
        canDownload: true
      }
    ],
    
    // المرفقات (مستندات العميل)
    attachments: [
      {
        id: 'ATT1',
        fileName: 'عقد العمل.pdf',
        fileType: 'PDF',
        fileSize: '2.3 MB',
        uploadDate: '2024-01-15',
        uploadedBy: 'العميل',
        category: 'عقود',
        description: 'عقد العمل الأصلي الموقع',
        documentUrl: '/documents/attachment-001.pdf',
        canDownload: true
      },
      {
        id: 'ATT2',
        fileName: 'كشف حساب بنكي.pdf',
        fileType: 'PDF',
        fileSize: '1.8 MB',
        uploadDate: '2024-01-20',
        uploadedBy: 'العميل',
        category: 'مستندات مالية',
        description: 'كشف الحساب البنكي لإثبات الرواتب',
        documentUrl: '/documents/attachment-002.pdf',
        canDownload: true
      },
      {
        id: 'ATT3',
        fileName: 'شهادة خبرة.pdf',
        fileType: 'PDF',
        fileSize: '0.5 MB',
        uploadDate: '2024-01-18',
        uploadedBy: 'العميل',
        category: 'مستندات شخصية',
        description: 'شهادة الخبرة الصادرة من الشركة',
        documentUrl: '/documents/attachment-003.pdf',
        canDownload: true
      }
    ],
    
    // تذاكر العميل
    clientTickets: [
      {
        id: 'TKT1',
        ticketNumber: 'TK-001',
        subject: 'استفسار عن موعد الجلسة القادمة',
        status: 'مغلقة',
        statusColor: '#10B981',
        priority: 'عادي',
        createdDate: '2024-11-10',
        lastUpdate: '2024-11-11',
        messages: 3,
        assignedTo: 'أ. محمد العتيبي'
      },
      {
        id: 'TKT2',
        ticketNumber: 'TK-002',
        subject: 'طلب تحديث عن حالة القضية',
        status: 'مفتوحة',
        statusColor: '#F59E0B',
        priority: 'عاجل',
        createdDate: '2024-11-28',
        lastUpdate: '2024-11-28',
        messages: 1,
        assignedTo: 'أ. محمد العتيبي'
      }
    ],
    
    // الرسوم الإضافية (تظهر فقط عند الوجود)
    additionalFees: [
      {
        id: 'FEE1',
        type: 'رسوم خبير',
        description: 'رسوم خبير محاسبي لتقييم المستحقات',
        amount: 5000,
        currency: 'ريال',
        status: 'مستحقة',
        statusColor: '#F59E0B',
        dueDate: '2024-12-10',
        invoiceNumber: 'INV-2024-001'
      },
      {
        id: 'FEE2',
        type: 'رسوم ترجمة',
        description: 'ترجمة مستندات من الإنجليزية للعربية',
        amount: 1500,
        currency: 'ريال',
        status: 'مدفوعة',
        statusColor: '#10B981',
        paidDate: '2024-11-15',
        invoiceNumber: 'INV-2024-002'
      }
    ],
    procedures: [
      {
        id: 'P1',
        date: '2024-01-15',
        action: 'تقديم الدعوى',
        responsible: 'أ. محمد العتيبي',
        status: 'مكتمل'
      },
      {
        id: 'P2',
        date: '2024-01-25',
        action: 'إعلان الخصم',
        responsible: 'المحكمة',
        status: 'مكتمل'
      },
      {
        id: 'P3',
        date: '2024-11-20',
        action: 'تقديم مذكرة دفاع',
        responsible: 'أ. محمد العتيبي',
        status: 'قيد التنفيذ'
      }
    ],
    documents: [
      {
        id: 'DOC1',
        name: 'عقد العمل',
        type: 'PDF',
        size: '2.3 MB',
        uploadDate: '2024-01-15',
        category: 'عقود'
      },
      {
        id: 'DOC2',
        name: 'كشف حساب بنكي',
        type: 'PDF',
        size: '1.8 MB',
        uploadDate: '2024-01-20',
        category: 'مستندات مالية'
      },
      {
        id: 'DOC3',
        name: 'شهادة خبرة',
        type: 'PDF',
        size: '0.5 MB',
        uploadDate: '2024-01-18',
        category: 'مستندات شخصية'
      }
    ],
    fees: [
      {
        id: 'F1',
        type: 'أتعاب المحاماة',
        amount: 15000,
        currency: 'ريال',
        status: 'مدفوع',
        paidDate: '2024-01-15'
      },
      {
        id: 'F2',
        type: 'رسوم المحكمة',
        amount: 2000,
        currency: 'ريال',
        status: 'مدفوع',
        paidDate: '2024-01-20'
      },
      {
        id: 'F3',
        type: 'رسوم الخبير',
        amount: 5000,
        currency: 'ريال',
        status: 'مستحق',
        dueDate: '2024-12-10'
      }
    ]
  },
  {
    id: 'WZ-2024-002',
    caseNumber: 'WZ-2024-002',
    title: 'قضية تجارية',
    type: 'تجاري',
    status: 'قيد المراجعة',
    statusColor: '#F59E0B',
    openDate: '2024-03-10',
    lastUpdate: '2024-11-25',
    assignedLawyer: 'أ. سارة الأحمدي',
    lawyerPhone: '+966 55 987 6543',
    court: 'المحكمة التجارية بجدة',
    nextHearing: '2024-12-20',
    description: 'نزاع تجاري حول عقد توريد',
    parties: [
      { role: 'المدعي', name: 'أحمد بن عبدالله السالم', type: 'client' },
      { role: 'المدعى عليه', name: 'مؤسسة الأمل التجارية', type: 'opponent' }
    ],
    hearings: [
      {
        id: 'H1',
        date: '2024-12-20',
        time: '09:00 صباحاً',
        location: 'المحكمة التجارية - القاعة 2',
        status: 'قادمة',
        notes: 'الجلسة الأولى'
      }
    ],
    decisions: [],
    requests: [],
    procedures: [
      {
        id: 'P1',
        date: '2024-03-10',
        action: 'تقديم الدعوى',
        responsible: 'أ. سارة الأحمدي',
        status: 'مكتمل'
      }
    ],
    documents: [
      {
        id: 'DOC1',
        name: 'عقد التوريد',
        type: 'PDF',
        size: '3.1 MB',
        uploadDate: '2024-03-10',
        category: 'عقود'
      }
    ],
    fees: [
      {
        id: 'F1',
        type: 'أتعاب المحاماة',
        amount: 20000,
        currency: 'ريال',
        status: 'مدفوع',
        paidDate: '2024-03-10'
      }
    ]
  },
  {
    id: 'WZ-2023-045',
    caseNumber: 'WZ-2023-045',
    title: 'قضية أحوال شخصية',
    type: 'أحوال شخصية',
    status: 'مغلقة',
    statusColor: '#10B981',
    openDate: '2023-08-20',
    lastUpdate: '2024-09-15',
    closeDate: '2024-09-15',
    assignedLawyer: 'أ. خالد المطيري',
    lawyerPhone: '+966 50 555 8888',
    court: 'محكمة الأحوال الشخصية بالدمام',
    nextHearing: null,
    description: 'قضية حضانة',
    parties: [
      { role: 'المدعي', name: 'أحمد بن عبدالله السالم', type: 'client' },
      { role: 'المدعى عليه', name: 'نورة بنت محمد الجهني', type: 'opponent' }
    ],
    hearings: [
      {
        id: 'H1',
        date: '2023-09-10',
        time: '10:00 صباحاً',
        location: 'محكمة الأحوال الشخصية - القاعة 1',
        status: 'منعقدة',
        notes: 'تم الاستماع للطرفين'
      },
      {
        id: 'H2',
        date: '2024-09-15',
        time: '11:00 صباحاً',
        location: 'محكمة الأحوال الشخصية - القاعة 1',
        status: 'منعقدة',
        notes: 'صدور الحكم النهائي'
      }
    ],
    decisions: [
      {
        id: 'D1',
        date: '2024-09-15',
        type: 'حكم نهائي',
        summary: 'الحكم لصالح المدعي',
        details: 'قررت المحكمة منح الحضانة للمدعي وفقاً للضوابط الشرعية'
      }
    ],
    requests: [],
    procedures: [
      {
        id: 'P1',
        date: '2023-08-20',
        action: 'تقديم الدعوى',
        responsible: 'أ. خالد المطيري',
        status: 'مكتمل'
      },
      {
        id: 'P2',
        date: '2024-09-15',
        action: 'صدور الحكم',
        responsible: 'المحكمة',
        status: 'مكتمل'
      }
    ],
    documents: [
      {
        id: 'DOC1',
        name: 'صك الزواج',
        type: 'PDF',
        size: '1.2 MB',
        uploadDate: '2023-08-20',
        category: 'وثائق رسمية'
      },
      {
        id: 'DOC2',
        name: 'الحكم النهائي',
        type: 'PDF',
        size: '2.5 MB',
        uploadDate: '2024-09-15',
        category: 'أحكام'
      }
    ],
    fees: [
      {
        id: 'F1',
        type: 'أتعاب المحاماة',
        amount: 12000,
        currency: 'ريال',
        status: 'مدفوع',
        paidDate: '2023-08-20'
      }
    ]
  }
];

export const getCaseById = (caseId) => {
  return mockCases.find(c => c.id === caseId || c.caseNumber === caseId);
};

export const getActiveCases = () => {
  return mockCases.filter(c => c.status !== 'مغلقة');
};

export const getClosedCases = () => {
  return mockCases.filter(c => c.status === 'مغلقة');
};
